import { lazy } from 'react';

export type MatxLayoutsType = {
  layout1?: React.ComponentType<any>;
  layout2?: React.ComponentType<any>;
};

export const MatxLayouts: MatxLayoutsType = {
  layout1: lazy(() => import('./Layout1/Layout1')),
};